import { render, staticRenderFns } from "./KnowledgeArticlePrompt.vue?vue&type=template&id=9d3a7272&scoped=true&"
import script from "./KnowledgeArticlePrompt.vue?vue&type=script&lang=ts&"
export * from "./KnowledgeArticlePrompt.vue?vue&type=script&lang=ts&"
import style0 from "./KnowledgeArticlePrompt.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./KnowledgeArticlePrompt.vue?vue&type=style&index=1&id=9d3a7272&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d3a7272",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCardActions,VDialog,VDivider,VIcon,VSpacer,VTooltip})
